import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import CreateUsernamePasswordService from './createusernamepassword.service';
import ICreateUsernamePasswordForm from './createusernamepasswordform.interface';
import CreateUsernamePasswordForm from './CreateUsernamePasswordForm.vue';
import PageService from '../../../core/page.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateUsernamePassword',
  props: {
    usernameText: null,
    passwordText: null,
    confirmPasswordText: null,
    submitButtonText: null,
    contactInformationText: null,
    formTitle: null,
    formDescription: null,
    passwordValidationText: null,
    token: null
  },
  emits: ['create'],
  setup(__props: any) {

const props = __props as {
    usernameText: string;
    passwordText: string;
    confirmPasswordText: string;
    submitButtonText: string;
    contactInformationText: string;
    formTitle: string;
    formDescription: string;
    passwordValidationText: string;
    token: string;
}





const showSpinner = ref(false);
const errorMessage = ref<string>('');
const usernameError = ref<boolean>(false);

const create = async(form: ICreateUsernamePasswordForm) => {
    errorMessage.value = '';
    showSpinner.value = true;

    const serverResponse = await CreateUsernamePasswordService.createUsernamePassword(form, props.token)
        .finally(() => showSpinner.value = false);

    if (serverResponse.createUsernamePasswordSuccess) {
        PageService.hardRedirect(serverResponse.redirectUrl);
    } else if (serverResponse.usernameInvalid) {
        usernameError.value = true;
    } {
        errorMessage.value = serverResponse.errorMessage;
    }
};

return { __sfc: true,props, showSpinner, errorMessage, usernameError, create, CreateUsernamePasswordForm }
}

})